import React from "react";
import "./hero.css";
import self from "../../Assets/Images/self.png";
const HeroSection = () => {
  return (
    <section id="hero-section" className="section hero-section">
      <div className="container-fluid h-100">
        <div className="row h-100">
          <div className="col-12 col-lg-6 h-100">
            <div className="hero-greeting w-100">
              <div className="div">
                <h1>Hi, I am</h1>
                <h2>Yoshi Bansal</h2>
              </div>
              <div className="socials">
                <a href="https://www.linkedin.com/in/yoshi-bansal-404aa218b/" target='_blank' rel='noreferrer'>
                  <i className="fab fa-linkedin"></i>
                </a>
                <a href="https://github.com/Yoshibansal" target='_blank' rel='noreferrer'>
                  <i className="fab fa-github"></i>
                </a>
                <a href="mailto://bansalyoshi@gmail.com" target='_blank' rel='noreferrer'>
                  <i className="fas fa-envelope"></i>
                </a>
                <a href="https://wa.me/918826832231" target='_blank' rel='noreferrer'>
                  <i className="fab fa-whatsapp"></i>
                </a>
              </div>
            </div>
            <div className="scroll-down">
              <div className="scroll-chevron">
                <div className="chevron"></div>
                <div className="chevron"></div>
                <div className="chevron"></div>
              </div>
              <div className="scoll-text">Know More</div>
            </div>
          </div>
        </div>
      </div>
      <div className="hero-img-container">
        <img src={self} alt="Yoshi Bansal" />
      </div>
    </section>
  );
};

export default HeroSection;
